module.exports = __webpack_public_path__ + "img/bathroom.1c94a70c.svg";